import React from 'react';
import cn from 'classnames';
import { withRouter, Link } from 'react-router-dom';

import Routes from 'routes';
import './styles.scss';

export const HeaderSectionsv2 = (props) => {
  const sections = [
    {
      title: 'Clients',
      path: Routes.ClientDashboardClients,
    },
    {
      title: 'Transactions',
      path: Routes.ClientDashboardTransactions,
    },
    {
      title: 'Reports',
      path: Routes.ClientDashboardReports,
    },
  ];

  const isActive = (pathname, sectionPath) => pathname.match(sectionPath);

  const { location } = props;

  return (
    <div className="Header-Sections">
      {
        sections.map(section => (
          <Link
            key={section.path}
            className={cn(
              'Header-Sections__Section',
              isActive(location.pathname, section.path) && 'Header-Sections__Section--active',
            )}
            to={section.path}
            tabIndex={0}
          >
            { section.title }
          </Link>
        ))
      }
    </div>
  );
};

export default withRouter(HeaderSectionsv2);
